module.exports = __webpack_public_path__ + "img/third-footer-icon.10f1a954.svg";